import useQuery from '../../../../ReactQuery/useQuery';
import { get } from '../../../../redux/api';
import type { SocialLoginPendingResponse } from '../../../../../shared/types/routes/auth/socialLogin';

export const getPendingSocialAuthQueryKey = () => ['pending-social-auth'];

function fetchPendingSocialAuth() {
  return get<SocialLoginPendingResponse>('/account/social/pending');
}

/**
 * Multi-org social login: fetch the candidate orgs + email for the pending OAuth identity.
 * Backend keeps the OAuth tokens server-side; the FE only sees what's needed to render the picker.
 */
export function useFetchPendingSocialAuth({ enabled }: { enabled: boolean }) {
  return useQuery<SocialLoginPendingResponse>({
    queryKey: getPendingSocialAuthQueryKey(),
    queryFn: fetchPendingSocialAuth,
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
